import { put, takeEvery } from "redux-saga/effects";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  ALL_ALBUM_TAGS_LIST_START: "ALL_ALBUM_TAGS_LIST_START",
  ALL_ALBUM_TAGS_LIST_SUCCESS: "ALL_ALBUM_TAGS_LIST_SUCCESS",
  ALL_ALBUM_TAGS_LIST_FAILED: "ALL_ALBUM_TAGS_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const allAlbumTagsListStart = (data) => ({
  type: actionType.ALL_ALBUM_TAGS_LIST_START,
  payload: data,
});

export const allAlbumTagsListSuccess = (data) => ({
  type: actionType.ALL_ALBUM_TAGS_LIST_SUCCESS,
  payload: data,
});

export const allAlbumTagsListFailed = (data) => ({
  type: actionType.ALL_ALBUM_TAGS_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function allAlbumTagsListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.ALL_ALBUM_TAGS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.ALL_ALBUM_TAGS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.ALL_ALBUM_TAGS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* allAlbumTagsListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        allAlbumTagsListSuccess({
          allAlbumTagsList: response.data.data,
        })
      );
    } else {
      messagePopup("", "High School List failed", "error");
      yield put(allAlbumTagsListFailed("High School List failed"));
    }
  } catch (error) {
    messagePopup("", "High School List failed", "error");
    yield put(allAlbumTagsListFailed("High School List failed"));
  }
}

//Watcher
export function* watchAllAlbumTagsListSaga() {
  yield takeEvery(actionType.ALL_ALBUM_TAGS_LIST_START, allAlbumTagsListSaga);
}
